import React from 'react'

export const AddressAndLogo = () => {
    return (
        <>
            <div className='col-12 col-sm-12 col-md-8 col-lg-10 col-xl-10'>
                <img
                    width={270}
                    height={270}
                    alt='poonalogo.jpg'
                    src="./poonalogo.jpg"
                    className="img-fluid"
                ></img>
            </div>
            <div className='col mt-3'>
                <div className='Address-bar'>
                    <p className="h5"><strong>POONAWALLA FINCORP LIMITED</strong></p>
                    <p><strong>CIN : </strong>L51504PN1978PLC209007</p>
                    <p><strong>Registered office : </strong> 201 and 202, 2nd Floor, AP81, Koregaon Park Annex, Mundhwa, Pune - 411036, Maharashtra </p>
                    <p><strong>Toll Free No : </strong>1800 266 3201 | <strong>E:</strong> <a href='mailto:customercare@poonawallafincorp.com'>customercare@poonawallafincorp.com</a> </p>
                    <p><strong>E : </strong> <a href='mailto:info@poonawallafincorp.com'>info@poonawallafincorp.com</a> | <strong>W : </strong> <a target="_blank" href='https://www.poonawallafincorp.com'>www.poonawallafincorp.com</a></p>
                </div>
            </div>
            <div className='col-4 col-sm-4 col-md-4 col-lg-2 col-xl-2'>

            </div>
        </>
    )
}
